import { createReducer, on, Action } from '@ngrx/store';
import * as actions from './address-provider.actions';

const initialState: OLO.State.AddressProvider = {
    search: null,
    places: [],
    geocoder: [],
};

const getPlacesForSearch = (places: OLO.State.AddressSugestionSearch[], searchTerm: string) => places.find((place) => place.search === searchTerm);
const getPlacesForGeolocation = (places: OLO.State.AddressSugestionGeolocation[], geolocation: OLO.DTO.GeolocationDto) =>
    places.find((place) => place.geolocation.Latitude === geolocation.Latitude && place.geolocation.Longitude === geolocation.Longitude);

export const addressProviderReducerFn = createReducer<OLO.State.AddressProvider>(
    initialState,
    on(actions.AddressProviderSearchRequest, (state, action) => {
        const newPlace: OLO.State.AddressSugestionSearch = {
            search: action.search,
            isDownloading: true,
            hasSucceeded: false,
            hasFailed: false,
            downloadedDate: null,
            data: null,
        };

        const existingPlace = getPlacesForSearch(state.places, action.search);

        return {
            ...state,
            search: action.search,
            places: existingPlace ? state.places.map((place) => (place.search === action.search ? newPlace : place)) : [...state.places, newPlace],
        };
    }),
    on(actions.AddressProviderSearchSuccessRequest, (state, action) => {
        const newPlace: OLO.State.AddressSugestionSearch = {
            search: action.search,
            isDownloading: false,
            hasSucceeded: true,
            hasFailed: false,
            downloadedDate: Date.now(),
            data: action.payload.AddressSugestions,
        };

        const existingPlace = getPlacesForSearch(state.places, action.search);

        return {
            ...state,
            places: existingPlace ? state.places.map((place) => (place.search === action.search ? newPlace : place)) : [...state.places, newPlace],
        };
    }),
    on(actions.AddressProviderSearchErrorRequest, (state, action) => {
        const newPlace: OLO.State.AddressSugestionSearch = {
            search: action.search,
            isDownloading: false,
            hasSucceeded: false,
            hasFailed: true,
            downloadedDate: null,
            data: null,
        };

        const existingPlace = getPlacesForSearch(state.places, action.search);

        return {
            ...state,
            places: existingPlace ? state.places.map((place) => (place.search === action.search ? newPlace : place)) : [...state.places, newPlace],
        };
    }),
    on(actions.AddressProviderReverseGeocodeRequest, (state, action) => {
        const newPlace: OLO.State.AddressSugestionGeolocation = {
            geolocation: action.geolocation,
            isDownloading: true,
            hasSucceeded: false,
            hasFailed: false,
            downloadedDate: null,
            data: null,
        };

        const existingPlace = getPlacesForGeolocation(state.geocoder, action.geolocation);

        return {
            ...state,
            geocoder: existingPlace ? state.geocoder.map((place) => (place.geolocation === action.geolocation ? newPlace : place)) : [...state.geocoder, newPlace],
        };
    }),
    on(actions.AddressProviderReverseGeocodeSuccessRequest, (state, action) => {
        const newPlace: OLO.State.AddressSugestionGeolocation = {
            geolocation: action.geolocation,
            isDownloading: false,
            hasSucceeded: true,
            hasFailed: false,
            downloadedDate: Date.now(),
            data: action.payload.AddressSugestions,
        };

        const existingPlace = getPlacesForGeolocation(state.geocoder, action.geolocation);

        return {
            ...state,
            geocoder: existingPlace ? state.geocoder.map((place) => (place.geolocation === action.geolocation ? newPlace : place)) : [...state.geocoder, newPlace],
        };
    }),
    on(actions.AddressProviderReverseGeocodeErrorRequest, (state, action) => {
        const newPlace: OLO.State.AddressSugestionGeolocation = {
            geolocation: action.geolocation,
            isDownloading: false,
            hasSucceeded: false,
            hasFailed: true,
            downloadedDate: null,
            data: null,
        };

        const existingPlace = getPlacesForGeolocation(state.geocoder, action.geolocation);

        return {
            ...state,
            geocoder: existingPlace ? state.geocoder.map((place) => (place.geolocation === action.geolocation ? newPlace : place)) : [...state.geocoder, newPlace],
        };
    }),
);

export function addressProviderReducer(state: OLO.State.AddressProvider | undefined, action: Action) {
    return addressProviderReducerFn(state, action);
}
